"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.5.4'] && _();
}
catch (e) { }
